export const TIMELINE = {
  PRODUCT_DETAILS: "تفاصيل المنتج / الخدمة",
  PRODUCT_PRICE: "سعر المنتج / الخدمة",
  POST_TRANSACTION: "نشر المعاملة",
};

export const NEW_TRANSACTION = {
  ADD_PRODUCT: "ﻗﻢ ﺑﺈﺿﺎﻓﺔ ﺗﻔﺎﺻﻴﻞ اﻟﻤﻨﺘﺞ/اﻟﺨﺪﻣﺔ",
  CREATE_TRANSACTION: "إنشاء معاملة آمنة",
  ATTACH_PHOTOS: "أرفق الصور الخاصة بالمنتج",
  PRICE_PRODUCTS: "ما هو سعر المنتج/الخدمة",
  SHIPPING_DETAILS: "تفاصيل الشحن",
  SR: "ريال سعودي",
  TERMS_CONDITION: "الموافقة على الشروط والأحكام",
  CREATED_SUCCESSFULLY: "تم إنشاء المعاملة بنجاح",
  COPY_LINK: "قم بنسخ الرابط ومشاركة طلبك لتستقبل اموالك بآمان",
  IS_THERE_SHIPPMENT: "هل يوجد شركة شحن؟",
  ZERO_FOR_FEE: "* اكتب صفر إذا لم يوجد رسوم",
  BACK: "السابق",
};

export const BUTTON = {
  TRACKING: "متابعة",
  CREATE_TRANSACTION: "إنشاء المعاملة",
  COPIED: "تم النسخ",
  COPY: "نسخ",
  CLOSE: "إغلاق",
};

export const FIELDS = {
  IO_AUXILIARY: "اسم المنتج/الخدمه",
  PRODUCT_DESCRIPTION: "وﺻﻒ اﻟﻤﻨﺘﺞ/اﻟﺨﺪﻣﺔ",
  WRITE_PRICE: "اكتب السعر هنا",
  SHIPPING_FEE: "رسوم الشحن",
  SERVICE_FEE: "رسوم الخدمة",
  RIAL: "ريال",
};

export const BANKS = {
  ENTER_INFO: "قم بإضافة حسابك البنكي",
  ENTER_INFO_DESC: "يجب عليك إضافة حسابك البنكي لتتمكن من إستقبال مستحقاتك",
  PROCEED: "أضف حسابك البنكي",
};

export const ERRORMESSAGES = {
  PRICE_ERROR: "لا يمكن إدخال سعر أكثر من ",
  SHIPPING_ERROR: "لا يمكن إدخال رسوم الشحن التي تزيد عن ",
};
